import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { translate } from 'react-i18next';
import { loanGoalsT } from '../../../../common/enums';
import { getRpmn } from '../../../../common/utils/mathHelpers';
import { currencyFormatter, percentageFormatter } from '../../../../common/utils/helpers';

@translate()
export default class StepSideBar extends Component {
  static propTypes = {
    t: PropTypes.func.isRequired,
    calculator: PropTypes.shape({
      goal: PropTypes.string.isRequired,
      amount: PropTypes.number.isRequired,
      months: PropTypes.number.isRequired,
      interest: PropTypes.number.isRequired,
      payment: PropTypes.number.isRequired,
      paymentTotal: PropTypes.number.isRequired,
      insurance: PropTypes.string,
      insuranceAmount: PropTypes.number.isRequired,
    }),
  };

  getGoalLabel() {
    return loanGoalsT[this.props.calculator.goal];
  }

  render() {
    const { t, calculator } = this.props;
    const { amount, months, interest, payment, paymentTotal, provisionFee, insuranceAmount } = calculator;
    const hasInsurance = !!calculator.insurance || insuranceAmount > 0;
    const monthlyInsuranceAmount = insuranceAmount || 0;

    return (
      <section className="step-sidebar">
        <h2 className="section-title">{t('Údaje o pôžičke')}</h2>
        <div className="side-info">
          <div className="side-info-row">
            <span>{t('Účel')}</span>
            <span>
              {t('Pôžička na')} "{this.getGoalLabel()}"
            </span>
          </div>
          <div className="side-info-row">
            <span>{t('Pôžička')}</span>
            <span>{currencyFormatter(amount)}</span>
          </div>
          <div className="side-info-row">
            <span>{t('Splatnosť')}</span>
            <span>
              {months} {t('mes.')}
            </span>
          </div>
          <div className="side-info-row">
            <span>{t('Úrok')}</span>
            <span>{percentageFormatter(interest)} p.a.</span>
          </div>
          <div className="side-info-row">
            <span>{t('RPMN')}</span>
            <span>{percentageFormatter(getRpmn(amount, hasInsurance ? (payment - monthlyInsuranceAmount) : payment, months))}</span>
          </div>
          {
            hasInsurance ?
            <div className="side-info-row">
                <span>{t('Poistenie')}</span>
                <span>
                  {currencyFormatter(monthlyInsuranceAmount)} / {t('mes.')}
                </span>
              </div>
              : null 
          }
          {
            hasInsurance ?
            <div className="side-info-row">
                <span>{t('Splátka')}</span>
                <span>
                  {currencyFormatter(payment - monthlyInsuranceAmount)} / {t('mes.')}
                </span>
              </div>
              :
              null
          }    
          <div className="side-info-row">
            <span>{hasInsurance ? t('Splátka + poistenie') : t('Splátka')}</span>
            <span>
              {currencyFormatter(payment)} / {t('mes.')}
            </span>
          </div> 
          <div className="side-info-row">
            <span>{t('Poplatok')}</span>
            <span>
              {currencyFormatter(provisionFee)}
            </span>
          </div>
          <div className="side-info-row">
            <span>{t('Spolu zaplatíte')}</span>
            <span>{currencyFormatter(paymentTotal)}</span>
          </div>
        </div>
      </section>
    );
  }
}



// WEBPACK FOOTER //
// ./src/features/onboarding/components/debtor/StepSideBar.js